export const PROGRESS_STATE_ERROR = 'PROGRESS_STATE_ERROR';
export const PROGRESS_STATE_IN_PROGRESS = 'PROGRESS_STATE_IN_PROGRESS';
export const PROGRESS_STATE_NONE = 'PROGRESS_STATE_NONE';
export const PROGRESS_STATE_OK = 'PROGRESS_STATE_OK';
